import { Avatar, Button, CircularProgress, Grid, IconButton, List, ListItem, ListItemAvatar, ListItemSecondaryAction, ListItemText } from '@material-ui/core';
import CreditCard from '@material-ui/icons/CreditCard';
import DeleteIcon from '@material-ui/icons/Delete';
import { CardElement, useElements, useStripe } from '@stripe/react-stripe-js';
import React, { useEffect, useState } from 'react';
import { ReusableSelect as Select } from 'components/reusable/select';
import { setCurrentCustomer, setPaymentMethods } from 'store/actions/actions';
import { useGlobalState } from 'store/reducers/reducer';
import { addPaymentMethod, deletePaymentMethod, getCurrentCustomer, getPaymentMethods, setPaymentMethodDefault } from 'store/sagas/sagas';
import './billing-payments.css';
export const PaymentMethods = () => {
    const { state, dispatch, asyncDispatch } = useGlobalState();
    const stripe = useStripe();
    const elements = useElements();
    useEffect(() => {
        setIsLoading(true);
        asyncDispatch(getPaymentMethods())
            .then((data) => {
            dispatch(setPaymentMethods(data));
            return data;
        })
            .then(async (paymentMethods) => {
            return asyncDispatch(getCurrentCustomer()).then((customer) => {
                dispatch(setCurrentCustomer(customer));
                for (const pm of paymentMethods) {
                    if (pm.id === customer.invoice_settings.default_payment_method) {
                        setDefaultCard({
                            id: pm.id,
                            name: pm.id
                        });
                    }
                }
            });
        })
            .catch(console.error)
            .finally(() => {
            setIsLoading(false);
        });
    }, []);
    const [defaultCard, setDefaultCard] = useState({ id: '', name: '' });
    const [isLoading, setIsLoading] = useState(false);
    const handleDeleteMethod = (paymentMethod) => {
        if (!elements || !stripe) {
            return;
        }
        setIsLoading(true);
        asyncDispatch(deletePaymentMethod(paymentMethod.id))
            .then(async () => {
            return asyncDispatch(getPaymentMethods());
        })
            .then((data) => {
            dispatch(setPaymentMethods(data));
            setIsLoading(false);
        })
            .catch((error) => {
            setIsLoading(false);
            console.error(error);
        });
    };
    const handleDefaultChange = (event) => {
        asyncDispatch(setPaymentMethodDefault(event.target.value))
            .then(async () => {
            return asyncDispatch(getPaymentMethods())
                .then((data) => {
                dispatch(setPaymentMethods(data));
            })
                .then(async () => {
                return asyncDispatch(getCurrentCustomer());
            })
                .then((customer) => {
                dispatch(setCurrentCustomer(customer));
                for (const pm of state.paymentMethods) {
                    if (pm.id === customer.invoice_settings.default_payment_method) {
                        setDefaultCard({
                            id: pm.id,
                            name: pm.id
                        });
                    }
                }
            });
        })
            .catch((error) => {
            setIsLoading(false);
            console.error(error);
        });
    };
    const handleSubmit = async (event) => {
        event.preventDefault();
        if (!elements || !stripe) {
            return;
        }
        const cardElement = elements.getElement(CardElement);
        if (!cardElement) {
            return;
        }
        setIsLoading(true);
        const { error, paymentMethod } = await stripe.createPaymentMethod({
            type: 'card',
            card: cardElement
        });
        const paymentMethodAttachData = {
            id: paymentMethod?.id
        };
        if (error) {
            console.error(error);
        }
        asyncDispatch(addPaymentMethod(paymentMethodAttachData))
            .then(async () => {
            return asyncDispatch(getPaymentMethods());
        })
            .then((data) => {
            dispatch(setPaymentMethods(data));
            setIsLoading(false);
        })
            .catch((error_) => {
            console.error(error_);
            setIsLoading(false);
        });
    };
    return (React.createElement("div", null,
        React.createElement("div", null,
            React.createElement("h1", null, "Payment Methods"),
            React.createElement("div", null,
                isLoading ? (React.createElement(CircularProgress, { size: "1.2rem", style: { color: '#290e88' } })) : state.paymentMethods.length > 0 ? (React.createElement("div", null,
                    React.createElement(Grid, { item: true, md: 6, xs: 12 },
                        React.createElement("div", null,
                            React.createElement(List, null, state.paymentMethods.map((paymentMethod) => {
                                return (React.createElement("div", { key: paymentMethod.id },
                                    React.createElement(ListItem, null,
                                        React.createElement(ListItemAvatar, null,
                                            React.createElement(Avatar, null,
                                                React.createElement(CreditCard, null))),
                                        React.createElement(ListItemText, { primary: `Card ending in ${paymentMethod.card.last4}`, secondary: state.customer?.invoice_settings
                                                .default_payment_method === paymentMethod.id
                                                ? 'Default'
                                                : null }),
                                        React.createElement(ListItemSecondaryAction, null,
                                            React.createElement(IconButton, { "aria-label": "delete", edge: "end", onClick: () => {
                                                    handleDeleteMethod(paymentMethod);
                                                } },
                                                React.createElement(DeleteIcon, null))))));
                            })))),
                    React.createElement("h2", { style: { margin: '4vh 0 3vh 0' } }, "Set Default Payment Method"),
                    React.createElement(Grid, { item: true, xs: 3 },
                        React.createElement(Select, { className: "select-group u-margin-top-large", items: state.paymentMethods.map((pm) => {
                                return {
                                    id: pm.id,
                                    name: `Card ending in ${pm.card.last4}`
                                };
                            }), name: "defaultCard", onChange: handleDefaultChange, value: defaultCard.name })))) : (React.createElement("div", null,
                    React.createElement("p", null, "There are no payment methods currently associated with your account. Without a payment method, invoices will be generated and sent to your account's email for you to manually pay"))),
                React.createElement("div", null,
                    React.createElement("h2", { style: { margin: '4vh 0 3vh 0' } }, "Add New Payment Method"),
                    React.createElement("form", null,
                        React.createElement(CardElement, { options: {
                                style: {
                                    base: {
                                        fontSize: '16px',
                                        color: '#424770',
                                        '::placeholder': {
                                            color: '#aab7c4'
                                        }
                                    },
                                    invalid: {
                                        color: '#9e2146'
                                    }
                                }
                            } }),
                        React.createElement("div", { className: "save-card-button" },
                            React.createElement(Button, { onClick: handleSubmit }, "Save Card"))))))));
};
